const fileDataFormat = "YYYYMMDD";
const displayDateFormat = "MMMM Do YYYY";

export { fileDataFormat, displayDateFormat };
